import React, { useState } from 'react';
import SiteContactList from './SiteContactList';
import SectionHeaderWithIcon, { SectionHeaderTypes } from '../../Common/SectionHeaderWithIcon';
import Pagination from '../../Common/Pagination';

export default function SiteContactsContainer({ siteContactsData, inspectorUserId, sectionName, sectionIcon }) {
    const [selectedPage, setSelectedPage] = useState(1);
    const pageSize = 30;

    function handleSelectPage(pageNum) {
        setSelectedPage(pageNum);
    }

    let noContacts;
    let contacts;

    if (siteContactsData !== undefined) {
        // Loading...

        if (siteContactsData.loading === false) {

            if (siteContactsData.contacts === undefined || siteContactsData.contacts.length === 0) {
                noContacts = (<div className="centeredMessage"><h3>No contacts available</h3></div>);
            }

            if (siteContactsData.contacts && siteContactsData.contacts.length > 0) {
                // contacts = siteContactsData.contacts.map((contact, index) => <SiteContact key={`${contact.email}-${index}`} /*isInspector={contact.id === inspectorUserId}*/ name={`${contact.first_Name} ${contact.last_Name}`} email={contact.email} phone={contact.phone} role={contact.role} />);

                contacts = (<SiteContactList
                    contactList={siteContactsData.contacts}
                    pageSize={pageSize}
                    selectedPage={selectedPage}
                    onSelectPage={handleSelectPage}
                />);
            }
        }
    }

    let pagination = (<Pagination itemCount={siteContactsData?.contacts?.length} pageSize={pageSize} selectedPage={selectedPage} hideWhenSinglePage={false} onSelectPage={handleSelectPage} />);
    return (<>
        <SectionHeaderWithIcon sectionName={sectionName} sectionIcon={sectionIcon} sectionHeaderType={SectionHeaderTypes.Primary} classes="" />
        <div className="ContactsContainer">
            <div className="Contacts">
                {contacts}
            </div>
            {noContacts}
        </div>
        {pagination}
    </>);
}